//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalCoBLandSalesWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total CoB Land Sales' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalCoBLandSalesWidget;
